import client from "@sanity/client";

export default client({
  projectId: "boa8k1h5",
  dataset: "production",
  useCdn: true,
  apiVersion: "2022-09-03",
});
